import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cllfpw8grf: FaireBrandEntity = {
  token: "b_cllfpw8grf",
  type: "brand",
  name: "Tiny Gift Society",
  avatarUrl:
    "https://cdn.faire.com/fastly/4c0034c6b375de75887178136b07aa25ee07c56d6c55111be86d2d03b1ff1269.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/69b859d6b97b1323cd3067116cf9c1e33bec7a358da775369ccfd789a9fa68c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4c0034c6b375de75887178136b07aa25ee07c56d6c55111be86d2d03b1ff1269.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/69b859d6b97b1323cd3067116cf9c1e33bec7a358da775369ccfd789a9fa68c8.jpeg",
  location: "Plano, TX, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 670,
  isTopShop: true,
  isInsider: true,
  description:
    'First time shoppers - Get great discounts by using our direct link!\nhttps://faire.com/direct/tinygiftsociety\n\nOh, just a Totally Awesome Shop for Thank You Gifts & Boutique Fillers.\n\nAt Tiny Gift Society, we know the power of a little gratitude. We source, curate, and design customer appreciation gifts that are both unique and affordable. We even have monthly featured boxes at various quantities, so you have more time -- for Boss-Girl stuff. ​ 👑\n\n"Appreciated Customers are Forever Customers"',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:30.018Z",
    importedBy: "entity-db-cli",
  },
};
